var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"w-full vx-col"},[_c('vs-tabs',{key:_vm.isSmallerScreen,staticClass:"tabs-shadow-none",attrs:{"value":_vm.active_step,"position":_vm.isSmallerScreen ? 'top' : 'top',"id":"profile-tabs"}},[(_vm.$canAny(['view-company-details-setting']))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-settings","label":!_vm.isSmallerScreen ? 'General Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-8"},[_c('list-of-settings')],1)]):_vm._e(),(_vm.$canAny([
        'view-carriers-setting',
        'view-ccp-items-setting',
        'view-margin-costs-setting',
        'view-formulation-compositions-setting',
        'view-production-codes-setting',
        'view-raw-material-qc-test-setting',
        'view-shipping-costs-setting',
        'view-sundry-costs-setting',
        'view-work-order-manufacturing-setting',
        'edit-work-order-manufacturing-setting'
      ]))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-cpu","label":!_vm.isSmallerScreen ? 'Manufacturing Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-0"},[_c('manufacturing-settings')],1)]):_vm._e(),(_vm.$canAny([
        'view-communication-subjects-setting',
        'view-snapshot-vam-types-setting',
        'view-currency-setting',
        'view-customer-source-setting',
        'view-incoterms-setting',
        'view-user-type-setting',
        'view-pack-size-setting',
        'view-manage-reports-setting',
        'view-orders-additional-costs-setting',
        'view-sales-order-changes-reasons-setting',
        'view-tax-codes-setting',
        'view-so-lead-time-setting',
        'edit-so-lead-time-setting',
        'view-otif-target-setting',
        'edit-otif-target-setting'
      ]))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-dollar-sign","label":!_vm.isSmallerScreen ? 'Customer & Trading Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-0"},[_c('customer-trading-settings')],1)]):_vm._e(),(_vm.$canAny([
        'view-holidays-setting',
        'view-staff-leaves',
        'view-manage-notifications-setting',
        'view-manage-reports-setting',
        'view-scheduled-task-templates',
        'view-company-address-setting',
        'edit-company-address-setting'
      ]))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-users","label":!_vm.isSmallerScreen ? 'Staff & Business Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-0"},[_c('staff-settings')],1)]):_vm._e(),(_vm.$canAny([
        'view-sage-nominal-code'
      ]))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-home","label":!_vm.isSmallerScreen ? 'SAGE Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-0"},[_c('f-m-s-settings')],1)]):_vm._e(),(_vm.$canAny([
        'view-raw-material-codes-setting'
      ]))?_c('vs-tab',{attrs:{"icon-pack":"feather","icon":"icon-box","label":!_vm.isSmallerScreen ? 'Supplier Settings' : ''}},[_c('div',{staticClass:"mt-4 ml-0 tab-general md:ml-4 md:mt-0"},[_c('supplier-settings')],1)]):_vm._e()],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }